export default __webpack_public_path__ + "static/media/link.151de304.svg";